// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"DealTabs_Tabs__BDR3U","Tab":"DealTabs_Tab__F4QIs","TabLabel":"DealTabs_TabLabel__1CoFe","Active":"DealTabs_Active__L3kcd"};